import _ from "lodash";
import {
  Component,
} from "react";
import moment from "moment";
import store from "CommonState/store";
import Breadcrumb from "CommonComponents/breadcrumb";
import {
  Alert,
  Button,
  Col,
  FormLabel,
  FormText,
  Row,
} from "react-bootstrap";

import {
  Awesome,
  Checkbox,
  CustomDatePicker,
  EditPanel,
  SchemaHeader,
  Spinner,
} from "CommonComponents/bricks";
import createEigenschaftenEditor, {
  createEigenschaftenEditorWithPosition,
} from "App/mn-editors";
import massnahmeApi, {
  ArbeitszeitRenderMethods,
  DeputatRenderMethods,
  FinanzierungRenderMethods,
  QualizielRenderMethods,
  renderKurzfristinfo,
  schemaArbeitszeitMn,
  schemaAufgabenbetarifMn,
  schemaDeputatMn,
  schemaFinanzierungMn,
  schemaLehrauftragMn,
  schemaMassnahme,
  schemaQualizielMn,
  schemaStellenaustarifMn,
  schemaTaetigkeitMn,
  StellenaustarifRenderMethods,
  TaetigkeitRenderMethods,
  validateMassnahme,
} from "Apis/massnahme-api";
import {
  DatePickerColWidth,
  LeftColWidth,
  requiredClass,
} from "CommonComponents/detail-view";
import Confirmation from "CommonComponents/confirmation";
import {
  createInjectsSelector,
  injectsFromSchemaAndRenderMethods,
} from "CommonCore/schema-util";
import {
  config,
  istArtTarifvertrag,
  istTypWerkvertrag,
  ROLLEN,
  userSachb,
  VERTRAGSARTEN,
  VERTRAGSARTEN_LEHRAUFTRAG,
} from "App/constants";
import apifetch from "CommonCore/apifetch";
import FinanzierungQVBHinweis from "App/mn-finanzierung-qvb-hinweis";
import MnÄndernPopup from "App/mn-aendern-popup";
import {
  togglePlugin,
} from "App/plugins";
import {
  withLocation,
} from "CommonCore/router-util";

const Taetigkeit = createEigenschaftenEditor([schemaTaetigkeitMn], TaetigkeitRenderMethods, [massnahmeApi.current], { property: "massnahmetaetigkeit", id: "mt_id", maxrows: 1 });
const actionTaetigkeit = {
  buttonUpName: "Tätigkeit bearbeiten",
  extraClass: "tatigkeit",
};

const Qualiziel = createEigenschaftenEditor([schemaQualizielMn], QualizielRenderMethods, [massnahmeApi.current], { property: "massnahmequaliziel", id: "mq_id", maxrows: 1 });
const actionQualiziel = {
  buttonUpName: "Qualifikationen bearbeiten",
  extraClass: "tatigkeit",
};

const StellenausTarif = createEigenschaftenEditor([schemaStellenaustarifMn], StellenaustarifRenderMethods, [massnahmeApi.current], { property: "massnahmetarif", id: "mtf_id", maxrows: 1 });
const actionStellenausTarif = {
  buttonUpName: "Stellenausschreibung bearbeiten",
  extraClass: "tatigkeit",
};

const AufgabenbeTarif = createEigenschaftenEditor([schemaAufgabenbetarifMn], [], [massnahmeApi.current], { property: "massnahmetarif", id: "mtf_id", maxrows: 1 });

const Deputat = createEigenschaftenEditorWithPosition([schemaDeputatMn], DeputatRenderMethods, [massnahmeApi.current], { property: "massnahmedeputat", id: "md_id" });
const actionDeputat = {
  buttonUpStyle: "link",
  buttonUpName: <Awesome name='close' />,
};

const Arbeitszeit = createEigenschaftenEditorWithPosition([schemaArbeitszeitMn], ArbeitszeitRenderMethods, [massnahmeApi.current], { property: "massnahmepaz", id: "mp_id" });
const actionArbeitszeit = {
  buttonUpStyle: "link",
  buttonUpName: <Awesome name='close' />,
};

const Finanzierung = createEigenschaftenEditorWithPosition([schemaFinanzierungMn], FinanzierungRenderMethods, [massnahmeApi.current], { property: "massnahmefinanz", id: "mfi_id" });
const actionFinanzierung = {
  buttonUpStyle: "link",
  buttonUpName: <Awesome name='close' />,
};

const panelData = {
  vertragsdaten: {
    action: {
      buttonUpName: "Vertragsdaten bearbeiten",
    },
  },
};

const injects = [
  ...injectsFromSchemaAndRenderMethods(schemaMassnahme),
];
const selectInjects = createInjectsSelector(injects);

export function generateAbDateField({ schema, message, entity, onChange, key }) {
  const bisField = schema.field.replace("gueltigab", "gueltigbis");
  const value = entity[schema.field];
  return (
    <Row key={key || schema.field} className={message ? "has-error" : ""}>
      <Col as={FormLabel} sm={LeftColWidth}><SchemaHeader {...schema} /></Col>
      <Col sm={DatePickerColWidth} {...requiredClass(schema)}>
        <CustomDatePicker
          value={value}
          onChange={dateString => onChange(schema, dateString)}
          isClearable={!(schema.required && schema.default)}
          name={"dateinput-" + schema.field} />
        {message && <FormText>{message}</FormText>}
      </Col>
      <Col sm={12 - DatePickerColWidth - LeftColWidth}>
        <Checkbox
          label='unbefristet'
          checked={entity[bisField] === null}
          onChange={({ target }) => onChange(bisField, target.checked ? null : undefined)}
        />
      </Col>
    </Row>
  );
}

@withLocation
@massnahmeApi.current
@massnahmeApi.actions
export default class MnDetailPage extends Component {
  render() {
    const {
      currentMassnahme,
    } = this.props;

    if (!currentMassnahme) {
      return <Spinner />;
    }

    return <div>
      <Breadcrumb data={[
        { name: "Maßnahmenplanung", path: "/massnahme" },
        { name: currentMassnahme && currentMassnahme.m_bez || "Neue Maßnahme" },
      ]} />

      <div className='detail-form bordered'>
        <MnDetailEditor />
      </div>
    </div>;
  }
}


@store(...injects, "user", "k_vertragsgrundLookup")
@massnahmeApi.current
@massnahmeApi.actions
export class MnDetailEditor extends Component {
  constructor() {
    super();
    this.state = {
      editsVertragsdaten: {},
      edits: {},
      errorMessage: null,
    };
  }

  get entityVertragsdaten() {
    const { currentMassnahme } = this.props;
    let entity = {};
    if (currentMassnahme) {
      entity = _.clone(currentMassnahme);
    }
    entity = _.assign(entity, this.state.editsVertragsdaten);
    return entity;
  }

  get entityLehrauftrag() {
    const { currentMassnahme } = this.props;
    let entity = {};
    if (currentMassnahme) {
      entity = _.clone(currentMassnahme);
    }
    entity = _.pickBy(entity, (value, key) => key.startsWith("ml"));
    return entity;
  }


  render() {
    const {
      saveMassnahmeDetail,
      deleteMassnahmeDetail,
      currentMassnahme,
      user,
      k_vertragsgrundLookup,
    } = this.props;
    const { errorMessage, veröffentlichen, warnungBeginn, showVerschieben } = this.state;

    const { entityVertragsdaten } = this;

    const istAst = user && user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER;
    const istSachb = user && userSachb(user);
    const istLehrauftrag = VERTRAGSARTEN_LEHRAUFTRAG.indexOf(entityVertragsdaten.m_artid) >= 0;
    const istWerkvertrag = istTypWerkvertrag(entityVertragsdaten.m_katid);
    const istTarif = istArtTarifvertrag(entityVertragsdaten.m_artid);
    const istWiss = istTarif && entityVertragsdaten.massnahmetarif.length && entityVertragsdaten.massnahmetarif[0].mtf_ist_wiss;
    const readOnly = true;

    const args = {
      istLehrauftrag,
      istWerkvertrag,
      istTarif,
      istWiss,
      istWHK: entityVertragsdaten && entityVertragsdaten.m_artid == VERTRAGSARTEN.WHK,
    };

    /*
     * Da es keine Bearbeitung mehr gibt, brauchen wir auch keine Veröffentlichung an dieser Stelle
     *  toolbarComponents={istDekan && !currentMassnahme.m_veroeffentlicht && <Button style={{marginRight: '1em'}} onClick={ this.beforeVeröffentlichen } >Veröffentlichen</Button>}
     */
    const toolbarComponents = istSachb && !istLehrauftrag && <Button onClick={this.beginVerschieben}>Beginn verschieben</Button>;

    const mySchema = _.cloneDeep(schemaMassnahme);
    if (istLehrauftrag) {
      const fldVertragsart = mySchema.table.find(x => x.field == "m_artid");
      if (fldVertragsart) {
        // Bei Lehrauftrag label ändern
        fldVertragsart.display = "Maßnahmeart";
      }
      mySchema.table = mySchema.table.filter(x => x.field != "m_staveroeffentlicht"); // geht auch anders ...
    }

    return <div>
      {showVerschieben && <MnÄndernPopup onClose={this.afterVerschieben} onCancel={this.cancelVerschieben} />}
      {veröffentlichen && <MassnahmeVeröffentlichen onConfirm={this.onVeröffentlichen} onClose={this.afterVeröffentlichen} />}
      {warnungBeginn && <AntragBeginnWarnung onConfirm={this.state.warnungContinue} onClose={this.afterWarnung} />}
      {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}

      <EditPanel
        header={<h4 key='h4'>Allgemeine {istLehrauftrag ? "Antragsdaten" : "Vertragsdaten"}</h4>}
        editable={!readOnly}
        defaultEditable={!istAst && (!entityVertragsdaten.m_bez || !entityVertragsdaten.m_eid)}
        action={panelData.vertragsdaten.action}
        editBox={panelData.vertragsdaten.editBox}
        readBox={panelData.vertragsdaten.readBox}
        schema={mySchema}
        injects={_.assign(selectInjects(this.props), { getEntity: entityVertragsdaten, istTarif: istTarif })} // getEntity für Schema-Funktionen injecten
        customControls={{ abdate: generateAbDateField }}
        entity={entityVertragsdaten}
        onClose={this.onCloseVertragsdaten}
        onChange={this.onChangeVertragsdaten}
        onBeginEdit={this.onBeginEdit}
        onSave={this.beforeSaveMassnahme}
        toolbarComponentsReadonly={toolbarComponents}
        bottomwell={renderKurzfristinfo(entityVertragsdaten, "M", k_vertragsgrundLookup)}
      />

      {togglePlugin("arbeitszeit", args) && <Arbeitszeit
        readonly={readOnly}
        additionalInjects={entityVertragsdaten}
        panelName='Arbeitszeit'
        panelNameNew='Neue Arbeitszeit hinzufügen'
        panelNamePosition='Arbeitszeit bearbeiten'
        action={actionArbeitszeit}
        typField='mne_metid'
        typUniqueField='mp_id'
        parentEntity={entityVertragsdaten}
        onSave={saveMassnahmeDetail}
        onDelete={deleteMassnahmeDetail}
        beforeSave={this.validateArbeitszeit}
        afterCommit={this.updateGUI}
        bottomwell={renderKurzfristinfo(entityVertragsdaten, "S", k_vertragsgrundLookup)}
      />}
      <Finanzierung
        readonly={readOnly}
        additionalInjects={entityVertragsdaten}
        panelName='Finanzierung'
        panelNameNew='Neue Finanzierung hinzufügen'
        panelNamePosition='Finanzierung bearbeiten'
        action={actionFinanzierung}
        typField='mne_metid'
        typUniqueField='mfi_id'
        parentEntity={entityVertragsdaten}
        onSave={saveMassnahmeDetail}
        onDelete={deleteMassnahmeDetail}
      >
        <br />
        <FinanzierungQVBHinweis massnahme={currentMassnahme} />
      </Finanzierung>
      {togglePlugin("tätigkeit", args) && <Taetigkeit
        readonly={readOnly}
        additionalInjects={entityVertragsdaten}
        panelName='Aufgabenbeschreibung für Hilfskräfte'
        action={actionTaetigkeit}
        typField='mne_metid'
        typUniqueField='mt_id'
        parentEntity={entityVertragsdaten}
        onSave={saveMassnahmeDetail}
      />}
      {togglePlugin("qualiziele", args) &&
        <Qualiziel
          readonly={readOnly}
          panelName='Qualifikationsziele'
          action={actionQualiziel}
          typField='mne_metid'
          typUniqueField='mq_id'
          parentEntity={entityVertragsdaten}
          onSave={saveMassnahmeDetail}
        />}

      {entityVertragsdaten && istLehrauftrag &&
        <EditPanel
          header={<h4 key='h4'>Lehrauftrag</h4>}
          editable={false}
          unshowSatus={false}
          schema={schemaLehrauftragMn}
          entity={this.entityLehrauftrag}
        />
      }

      {entityVertragsdaten && istTarif &&
        <StellenausTarif
          readonly={readOnly}
          panelName='Stellenausschreibung'
          action={actionStellenausTarif}
          typField='mne_metid'
          typUniqueField='mtf_id'
          parentEntity={entityVertragsdaten}
          onSave={saveMassnahmeDetail}
        />
      }

      {entityVertragsdaten && istTarif &&
        <AufgabenbeTarif
          readonly={readOnly}
          panelName='Aufgabenbeschreibung'
          typField='mne_metid'
          typUniqueField='mtf_id'
          parentEntity={entityVertragsdaten}
          onSave={saveMassnahmeDetail}
        />
      }

      {entityVertragsdaten && togglePlugin("deputat", args) && <Deputat
        readonly={readOnly}
        panelName='Deputat'
        panelNameNew='Neues Deputat hinzufügen'
        panelNamePosition='Deputat bearbeiten'
        action={actionDeputat}
        typUniqueField='md_id'
        parentEntity={entityVertragsdaten}
      />}

    </div>;
  }

  onBeginEdit = () => {
    this.setState({ errorMessage: null });
  };

  beforeVeröffentlichen = () => {
    const { currentMassnahme } = this.props;
    if (!currentMassnahme.m_vorgesehen || String(currentMassnahme.v_vorgesehen).trim().length == 0) {
      this.setState({ errorMessage: "Bitte geben Sie vor dem Veröffentlichen ein, für wen die Maßnahme vorgesehenen ist." });
      return false;
    }
    const minWochen = config.getValue("EINSTELLUNG_WARNUNG_WOCHEN");
    const pufferUnterschritten = moment(currentMassnahme.m_gueltigab).subtract(minWochen, "week") < moment();
    if (pufferUnterschritten) {
        // Warnung zwischenschalten
      this.setState({ warnungBeginn: true,
                      warnungContinue: () => {
                        this.setState({ warnungBeginn: false, veröffentlichen: true });
                      } });
    } else {
        // Veröffentlichungspopup
      this.setState({ veröffentlichen: true });
    }
  };

  // ----------------------------------- Veröffentlichen ----------------------
  onVeröffentlichen = async() => {
    const { currentMassnahme } = this.props;
    try {
      await apifetch("/api/shkantrag/massnahme/veroeffentlicht", {
        method: "POST",
        body: { m_id: currentMassnahme.m_id },
      });
      currentMassnahme.m_veroeffentlicht = true;
      this.props.updateMassnahmeInStore(currentMassnahme.m_id, currentMassnahme);
      this.setState({ errorMessage: null, veröffentlichen: false });
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
  afterVeröffentlichen = () => {
    this.setState({ veröffentlichen: false });
  };
  // ----------------------------------- Veröffentlichen ----------------------

  onCloseVertragsdaten = () => {
    this.setState({ editsVertragsdaten: {} });
  };

  onChangeVertragsdaten = change => {
    const { editsVertragsdaten } = this.state;
    _.assign(editsVertragsdaten, change);
    this.setState({ editsVertragsdaten: editsVertragsdaten });
  };

  beforeSaveMassnahme = (entity, toggleCallback) => {
    // Validierungen vor dem Speichern

    this.toggleCallback = toggleCallback; // Toggle-Methode des Editpanels merken

    const copy = _.cloneDeep(this.entityVertragsdaten);
    const statusValidate = validateMassnahme(this.props.user, copy);
    if (statusValidate) {
      const err = Error();
      err.response = statusValidate;
      throw err;
    }

    // Abbrechbare Warnung bei Unterschreiten des sicheren Zeitpuffers
    const minWochen = config.getValue("EINSTELLUNG_WARNUNG_WOCHEN");
    const pufferUnterschritten = moment(copy.m_gueltigab).subtract(minWochen, "week") < moment();
    if (pufferUnterschritten) {
      // Warnung zwischenschalten
      this.setState({ warnungBeginn: true, warnungContinue: this.saveMassnahme });
      const err = Error();
      err.silent = true; // kein Fehler, muss hier nur den Kontrollfluss via Throw abbrechen
      throw err;
    } else {
      // Speichern auslösen
      this.saveMassnahme();
    }
  };

  saveMassnahme = async() => {
    // Maßnahme speichern
    const { warnungBeginn } = this.state;

    const copy = _.cloneDeep(this.entityVertragsdaten);
    await this.props.saveMassnahme(copy);

    if (warnungBeginn) {
      // Das Popup hatte uns unterbrochen, Editmode im Panel togglen
      this.toggleCallback && this.toggleCallback();
      this.toggleCallback = null; // nach Verwendung verwerfen
    }

    this.setState({ entity: copy, warnungBeginn: false });
    this.onCloseVertragsdaten();
  };
  afterWarnung = () => {
    // Abbruch nach Warnung
    this.setState({ warnungBeginn: false });
  };

  validateArbeitszeit = az => {
    const details = {};
    if (!_.isEmpty(details)) {
      const e = Error();
      e.response = { nachricht: "Es sind Fehler bei der Validierung aufgetreten", details: details };
      throw e;
    }
    return az;
  };

  saveDetail = (entity, data, arrayinfo) => {
    this.props.saveMassnahmeDetail(entity, data, arrayinfo);
    this.props.clearMassnahmeList();
    this.forceUpdate();
  };

  bevoreSaveFinanzierung = data => {
    return data;
  };


  // --- Verschieben ---
  beginVerschieben = () => {
    this.setState({ showVerschieben: true });
  };
  cancelVerschieben = () => {
    this.setState({ showVerschieben: false });
  };
  afterVerschieben = () => {
    // Popup schließen und neu laden
    this.setState({ showVerschieben: false }, () => {
      this.props.clearMassnahmeList();
      this.props.retrieveMassnahmeList();
    });
  };
}

@massnahmeApi.actions
@store("currentAntragInflight")
class MassnahmeVeröffentlichen extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { onClose, currentAntragInflight: inflight } = this.props;
    const { errorMessage } = this.state;

    return (
      <Confirmation
        header='Maßnahme veröffentlichen'
        body={<span>Sind Sie sicher, dass Sie diese Maßnahme veröffentlichen möchten?<br /> Nach der Veröffentlichung sind keine Korrekturen oder Änderungen mehr möglich.</span>}
        action='Veröffentlichen'
        actionStyle='primary'
        inflight={inflight}
        onCancel={onClose}
        onConfirm={this.onConfirm}
        errorMessage={errorMessage}
      />
    );
  }

  onConfirm = () => {
    this.props.onConfirm();
  };
}

@store("user")
export class AntragBeginnWarnung extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { onClose, onConfirm } = this.props;
    const { errorMessage } = this.state;

    const minWochen = config.getValue("EINSTELLUNG_WARNUNG_WOCHEN");
    return (
      <Confirmation
        header='Warnung Antragsbeginn'
        action='Fortfahren'
        actionStyle='primary'
        onCancel={onClose}
        onConfirm={onConfirm}
        errorMessage={errorMessage}
      >

        <p>Der geplante Vertragsbeginn liegt weniger als {minWochen} Wochen in der Zukunft.</p>

        <p>Es kann nicht gewährleistet werden, dass das Dienstverhältnis zum geplanten Vertragsbeginn
          angetreten werden kann. Bitte planen Sie wenn möglich eine Vorlaufzeit von mind. {minWochen} Wochen für den Antrag ein</p>

      </Confirmation>

    );
  }
}
